import React from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export interface RowAction {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?: "default" | "destructive";
  hidden?: boolean;
}

interface RowActionsMenuProps {
  actions: RowAction[];
  disabled?: boolean;
}

const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  actions,
  disabled,
}) => {
  const visibleActions = actions.filter((a) => !a.hidden);
  if (visibleActions.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-8 w-8 p-0 hover:bg-muted"
          disabled={disabled}
        >
          <MoreHorizontal className="h-4 w-4 text-slate-500" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="rounded-xl shadow-lg border-slate-100"
      >
        {visibleActions.map((action, i) => (
          <DropdownMenuItem
            key={i}
            onClick={action.onClick}
            className={`cursor-pointer ${action.variant === "destructive" ? "text-red-600" : ""}`}
          >
            {action.icon}
            <span className="ml-2">{action.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default RowActionsMenu;
